import axios from 'axios';
import '../assets/lib/jquery.min.js'

const Storage = {}

Storage.get = function(name) {
    return JSON.parse(sessionStorage.getItem(name))
}

Storage.set = function(name, val) {
    sessionStorage.setItem(name, JSON.stringify(val))
}

Storage.add = function(name, addVal) {
    let oldVal = Storage.get(name)
    let newVal = oldVal.concat(addVal)
    Storage.set(name, newVal)
}

var ajax = {
    get: function(url, data, callback, token) {
        var contenttype = "text/plain";
        http({
            method: "get",
            headers: {
                "Content-Type": contenttype,
                "Token": token
            },
            url: url,
            params: data,
        }).then(function(res) {
            httpcallback(res, callback);
        }).catch(function(err) {
            errCallBack(err, callback);
        })
    },
    post: function(url, udata, callback, token) {
        var contenttype = "application/json;charset=utf-8";
        if (typeof(udata) == "string") {
            contenttype = "application/x-www-form-urlencoded;charset=utf-8";
        }
        http({
            method: "post",
            headers: {
                "Content-Type": contenttype,
                "Token": token
            },
            url: url,
            data: udata,
            timeout: 60000,
            responseType: 'text'
        }).then(function(res) {
            httpcallback(res, callback);
        }).catch(function(err) {
            errCallBack(err, callback);
        })
    },
    postForm: function(url, udata, callback, token) {
        http({
            method: "post",
            headers: {
                "Content-Type": "multipart/form-data",
                "Token": token
            },
            url: url,
            data: udata,
            timeout: 600000,
            responseType: 'text'
        }).then(function(res) {
            httpcallback(res, callback);
        }).catch(function(err) {
            errCallBack(err, callback);
        })
    },
    posts: function(url, udata, callback) {
        var contenttype = "application/x-www-form-urlencoded; charset=UTF-8";
        http({
            method: "post",
            headers: {
                "Content-Type": contenttype
            },
            url: url,
            data: udata,
            timeout: 60000
        }).then(function(res) {
            httpcallback(res, callback);
        }).catch(function(err) {
            errCallBack(err, callback);
        })
    }
}
let httpcallback = function(res, callback) {
    if (res.status == 200) {
        callback(res.data);
        return;
    }
    var err = {
        Ret: -1,
        Msg: '返回状态码' + res.status
    };
    if (res.status == 401) {
        err.Ret = 401;
    }
    callback(err);
}
let errCallBack = function(err, callback) {

    if (err.message.indexOf("timeout") > -1) {
        err.message = "连接超时，请稍后重试。";
    }

    var errdata = {
        Ret: -1,
        Msg: err.message
    };
    if (err.response != undefined && err.response.status == 401) errdata.Ret = 401;
    callback(errdata);
}

let http;
let payurl = "payurl";
let showcheckbox = "showcheckbox";
let configCallbackUrl = "configCallbackUrl";
let InsNameCn = "InsNameCn";
let InsNameEn = "InsNameEn";
let isShowCashRecord = "isShowCashRecord";
let isShowPhone = "isShowPhone";
let isShowIdCard = "isShowIdCard";
let RechargeInputAmountType = "RechargeInputAmountType";
let remitHint = "remitHint";
let OfflineRandomAccount = "OfflineRandomAccount";
let SubCertificationUpload = "SubCertificationUpload";
let SubCertificationFileUrl = "SubCertificationFileUrl";
// var config = axios.get('../../static/config.json').then(res => {
//     let apiUrl = res.data.ApiUrl;
//     http = axios.create({
//         baseURL: apiUrl, //"http://futures.mlinsoft.com:9908/api/", //config.ApiUrl,//'http://192.168.1.205:8000/api/',
//         withCredentials: true,
//     });
// });

$.ajax({
    type: "get",
    url: "../../static/config.json",
    async: false,
    success: function(data) {

        let queryurl = data.InsuserApiUrl;

        if (data.InsuserApiUrl.includes('*')) {

            queryurl = window.location.protocol + '//' + window.location.hostname + data.InsuserApiUrl.split("*")[1]
        }


        http = axios.create({
            baseURL: queryurl, //"http://futures.mlinsoft.com:9908/api/", //config.ApiUrl,//'http://192.168.1.205:8000/api/',
            withCredentials: true,
            headers: { 'BrowserHost': window.location.href }
        });

        if (data.PayUrl.includes('*')) {

            data.PayUrl = window.location.protocol + '//' + window.location.hostname + data.PayUrl.split("*")[1]
        }

        Storage.set(payurl, data.PayUrl);
        Storage.set(showcheckbox, data.showcheckbox);
        Storage.set(configCallbackUrl, data.configCallbackUrl);
        Storage.set(InsNameCn, data.InsNameCn);
        Storage.set(InsNameEn, data.InsNameEn);
        Storage.set(isShowCashRecord, data.isShowCashRecord);
        Storage.set(isShowPhone, data.isShowPhone);
        Storage.set(isShowIdCard, data.isShowIdCard);
        Storage.set(RechargeInputAmountType, data.RechargeInputAmountType);
        Storage.set(remitHint, data.remitHint);
        Storage.set(OfflineRandomAccount, data.OfflineRandomAccount);
        Storage.set(SubCertificationUpload, data.SubCertificationUpload);
        Storage.set(SubCertificationFileUrl, data.SubCertificationFileUrl);
        sessionStorage.setItem('InsToRegisterUrl', JSON.stringify(data.InsToRegisterUrl))
        sessionStorage.setItem('RechargeConfig', JSON.stringify(data.RechargeConfig))
    }
});

export default ajax;


// WEBPACK FOOTER //
// ./src/api/index.js